/**
 * Utility functions for handling JWT tokens and user information
 */

/**
 * Get user email from JWT token
 * @returns {string|null} User email if token is valid, null otherwise
 */
export const getUserEmail = () => {
  try {
    const token = localStorage.getItem("jwt");

    if (!token) {
      return null;
    }

    // Validate JWT format (should have 3 parts separated by dots)
    const parts = token.split(".");
    if (parts.length !== 3) {
      console.warn("Invalid JWT format: token does not have 3 parts");
      return null;
    }

    // Decode the payload
    const payload = JSON.parse(atob(parts[1]));

    if (!payload?.email) {
      console.warn("Invalid JWT: email claim not found in token payload");
      return null;
    }

    return payload.email;
  } catch (error) {
    console.error("Error parsing JWT token:", error);
    return null;
  }
};

/**
 * Check if the current user is a restricted user
 * Restricted users have access only to specific features
 * @param {string} restrictedEmail - The email to check against
 * @returns {boolean} True if user is restricted, false otherwise
 */
export const isRestrictedUser = (restrictedEmail) => {
  const userEmail = getUserEmail();

  // if userEmail is null, treat as non-restricted (could be unauthenticated or token issue)
  return userEmail ? userEmail === restrictedEmail : true;
};
